// piano-frontend/src/utils/push.js
// 푸시 구독을 한 번에 켜는 재사용 유틸. (PushNotificationManager의 구독 로직을 요약 추출)
import api from '../api/axios';

export function isPushSupported() {
  return typeof navigator !== 'undefined'
    && 'serviceWorker' in navigator
    && typeof window !== 'undefined'
    && 'PushManager' in window
    && typeof Notification !== 'undefined';
}

export function getNotificationPermission() {
  if (typeof Notification === 'undefined') return 'unsupported';
  return Notification.permission; // 'default' | 'granted' | 'denied'
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// 권한 요청 + 구독 + 서버 등록. 성공 시 true 반환.
// 실패 시 code가 담긴 Error throw ('denied' | 'unconfigured' | 'unsupported' | 'not_granted' 등)
export async function enablePush() {
  if (!isPushSupported()) {
    const e = new Error('이 기기에서는 푸시를 지원하지 않습니다.');
    e.code = 'unsupported';
    throw e;
  }

  if (Notification.permission === 'denied') {
    const e = new Error('알림 권한이 차단되어 있습니다.');
    e.code = 'denied';
    throw e;
  }

  const res = await api.get('/config/vapid-public-key');
  if (!res.data?.configured || !res.data?.publicKey) {
    const e = new Error('푸시 서비스가 구성되지 않았습니다.');
    e.code = 'unconfigured';
    throw e;
  }
  const vapidPublicKey = res.data.publicKey;

  const permission = await Notification.requestPermission();
  if (permission === 'denied') {
    const e = new Error('알림 권한이 거부되었습니다.');
    e.code = 'denied';
    throw e;
  }
  if (permission !== 'granted') {
    const e = new Error('알림 권한이 필요합니다.');
    e.code = 'not_granted';
    throw e;
  }

  const registration = await navigator.serviceWorker.ready;
  const existing = await registration.pushManager.getSubscription();
  if (existing) await existing.unsubscribe();

  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
  });

  await api.post('/push/subscribe', { subscription: subscription.toJSON() });
  try { localStorage.setItem('last_vapid_key', vapidPublicKey); } catch { /* noop */ }

  return true;
}
